<template>
  <bk-page class="paymentDetailPage" pageType="navPage" :navBarInfo="navBarInfo">
		<bk-view class="view-container">
			<bk-view class="view-content">
				<bk-view class="view-shop-main">
					<bk-view class="view-title">
						<bk-title>{{curRows.compName}}</bk-title>
					</bk-view>
					<bk-view class="view-address">{{curRows.compAddress || '-'}}</bk-view>
					<bk-view class="view-bill-main">
						<bk-view>No.{{curRows.billNo}}</bk-view>
						<bk-date :date="curRows.date" :curShop="curRows" />
					</bk-view>
				</bk-view>
				<bk-view class="view-commodity-main">
					<bk-view class="view-commodity-list" v-for="detailItem in formData.contentList" :key="detailItem.goodsId">
						<bk-view class="view-commodity-item">
							<bk-view class="view-name">{{detailItem.name}}</bk-view>
							<bk-view class="view-right">
								<bk-view class="view-num">x{{detailItem.quantity}}</bk-view>
								<bk-price class="view-price" :value="detailItem.price" fontSize="12px"></bk-price>
							</bk-view>
						</bk-view>
						<bk-view class="view-pay-main">
							<bk-view class="view-pay-item"  v-for="payMethodItem in detailItem.itemsPaymentList" :key="payMethodItem.payMethodId">
								<bk-view class="view-name">{{payMethodItem.payMethodName}}</bk-view>
								<bk-view class="view-right">
									<template  v-if="$bk_Global.dkPayments.includes(payMethodItem.payMethodCode)">
										<bk-view>
											<span>{{ detailItem.quantity || 1 }}</span>
											<bk-lang code="userInfo_paymentDetail_deduction"></bk-lang>
										</bk-view>
										<bk-price v-if="systemInfo['MASE199']" class="view-price" fontSize="12px" :value="payMethodItem.paymentAmount"></bk-price>
									</template>
									<bk-price v-else class="view-price" fontSize="12px" :value="payMethodItem.paymentAmount"></bk-price>
								</bk-view>
							</bk-view>
						</bk-view>
						<bk-view class="view-emp-main" v-if="detailItem.staffNames">{{detailItem.staffNames}}</bk-view>
					</bk-view>
				</bk-view>
				<bk-view class="view-cost-main" v-if="curRows.costList?.length">
					<bk-view class="view-cost-item" v-for="costItem in curRows.costList" :key="costItem.id">
						<bk-view class="view-name">{{costItem.showName}}</bk-view>
						<bk-view class="view-right">
							<bk-view class="view-num">{{costItem.rateText}}</bk-view>
							<bk-price class="view-price" :value="costItem.amount"></bk-price>
						</bk-view>
					</bk-view>
				</bk-view>
				<bk-view class="view-footer-main">
					<bk-view class="view-footer-item">
						<bk-view class="view-footer-right">
							<bk-lang class="view-label" code="userInfo_paymentDetail_subtotal"></bk-lang>
							<bk-price class="view-price" :value="curRows.subTotal"></bk-price>
						</bk-view>
					</bk-view>
					<bk-view class="view-footer-item">
						<bk-view class="view-footer-right">
							<bk-lang class="view-label" code="userInfo_paymentDetail_taxes"></bk-lang>
							<bk-price class="view-price" :value="curRows.taxes"></bk-price>
						</bk-view>
					</bk-view>
					<bk-view class="view-footer-item">
						<bk-view class="view-footer-right">
							<bk-lang class="view-label" code="userInfo_paymentDetail_total"></bk-lang>
							<bk-price class="view-price" :value="curRows.totalAmount"></bk-price>
						</bk-view>
					</bk-view>
					<bk-view class="view-footer-item">
						<bk-view class="view-footer-right">
							<bk-lang class="view-label" code="userInfo_paymentDetail_tips"></bk-lang>
							<bk-price class="view-price" :value="curRows.tips"></bk-price>
						</bk-view>
					</bk-view>
				</bk-view>
			</bk-view>
		</bk-view>
  </bk-page>
</template>

<script>
	import { baseReq, billReq } from '@/reqService';

	export default {
		name:'paymentDetail',
		props:{
			curRows:Object
		},
		data (){
			return {
				systemInfo:{},
				formData:{},
				navBarInfo: {
					langCode_title:'userInfo_paymentDetail_title',
					backFlag: true,
				},
			};
		},
		mounted (){
			this.initData();
		},
		methods:{
			initData (){
				this.requestGetOrderInfoById();
				this.requestGetSystemParamsByCodes();
			},
			async requestGetOrderInfoById (){
				let res = await billReq.requestGetOrderInfoById(this, { id: this.curRows.billId });
				this.formData = res;
			},
			async requestGetSystemParamsByCodes (){
				const { custId, compId } = this.curRows;
				let params = {
					custId, compId, 
					paramCodes:[
						'MASE199', // 单据详情权益抵扣详情: 次数  次数+金额
					],
				};
				let res = await baseReq.requestGetFindSystemByCodes(this, params);
				this.systemInfo = res;
			}
		}
	};
</script>

<style lang="less">
@import './paymentDetail.less';
</style>